import MainMenu from '@/components/foundation/main-menu/MainMenu'
import Distributors from '@/view/record/distributor/Distributors'
import DistributorEditor from '@/view/record/distributor/components/edit/DistributorEditor'

export const DistributorsRoute = {
  path: '/distributors',
  name: 'Distributors',
  components: {
    default: Distributors,
    mainMenu: MainMenu
  },
  meta: {
    auth: true,
    mainArea: 'record',
    area: 'record-user',
    breadcrumb: [
      { name: 'Cadastro', link: '/record' },
      { name: 'Distribuidores' }
    ]
  }
}

export const DistributorEdit = {
  path: '/distributor/:id',
  name: 'DistributorEditor',
  components: {
    default: DistributorEditor,
    mainMenu: MainMenu
  },
  meta: {
    auth: true,
    mainArea: 'record',
    area: 'record-user',
    breadcrumb: [
      { name: 'Cadastro', link: '/record' },
      { name: 'Distribuidor', link: '/distributors' },
      { name: 'Edição' }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/router/record/Distributors.js